import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "panel"]
  static classes = ["active", "panel"]
  static values = { index: Number, count: Number }

  select(event) {
    this.indexValue = Number(event.params.index)
  }

  onKey(event) {
    if (event.target.closest?.("input, textarea, select")) return

    if (["ArrowRight", "ArrowDown"].includes(event.key)) {
      this.indexValue = (this.indexValue + 1) % this.countValue
    } else if (["ArrowLeft", "ArrowUp"].includes(event.key)) {
      this.indexValue = (this.indexValue - 1 + this.countValue) % this.countValue
    } else {
      return
    }

    event.preventDefault()
  }

  indexValueChanged(value) {
    this.itemTargets.forEach((el) => {
      const on = this.indexFor(el) === value
      el.classList.toggle(this.activeClass, on)
      el.setAttribute("aria-current", on)
    })

    this.panelTargets.forEach((el) => {
      const on = this.indexFor(el) === value
      el.classList.toggle(this.panelClass, on)
      el.setAttribute("aria-expanded", on)
    })
  }

  indexFor(el) {
    return Number(el.getAttribute(`data-${this.identifier}-index-param`))
  }
}
